<template>
    <div>
      <draggable 
        v-model="Data"
        tag="div"
        class="row"
        @end="ChangeTableOrder(Data)"
        :options="{ handle: '.handle-table', class: 'row' }"
      >
        <b-col
          :id="'Section-' + Data + '-table-' + item.id"
          :key="'Section-' + Data + '-table-' + index"
          :md="item.col"
          v-for="(item, index) in Data"
          class="mb-2"
        >
          <div class="border p-2">
            <div class="d-flex justify-content-between align-items-center">
              <feather-icon
                icon="MenuIcon"
                size="18"
                class="cursor-pointer handle-table mr-2"
              />
              <div>
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-success"
                  class="btn-icon rounded-circle mr-1"
                  @click="updateTable(index)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="btn-icon rounded-circle"
                  @click="removeItem(index)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </div>
            </div>
            <div class="mt-2 ql-editor">
              <h3 v-if="item.title[currentLocale]">{{ item.title[currentLocale] }}</h3>
                <div  class="d-flex mt-1 py-1 px-1 text-center" style="background-color: azure;">
                    <div :style="'width:'+item.class_column[i].width+'%'" v-for="(c,i) in item.columns">
                        <span v-if="c.title[currentLocale]" v-html="c.title[currentLocale]"></span>
                    </div>
                    
                </div>
                <div v-for="(ro,i) in item.rows"  class="d-flex pt-1 px-1">
                    <div v-for="(rc,ind) in ro" :style="'width:'+item.class_column[ind].width+'%'"  >
                        <span v-if="rc.text[currentLocale]" v-html="rc.text[currentLocale]"></span>
                        
                    </div>
                    
                </div>
                
                <div class="mt-1" v-if="item.note[currentLocale]" v-html="item.note[currentLocale]"></div>

             
             
              
            </div>
          </div>
        </b-col>
      </draggable>
    </div>
  </template>
  
  <script>
    import draggable from "vuedraggable";
    import Ripple from "vue-ripple-directive";
    import { ref, onUnmounted } from "@vue/composition-api";
    import store from "@/store";
    import { BRow, BCol, BSpinner, BButton, VBModal } from "bootstrap-vue";
    import "quill/dist/quill.core.css";
    
    export default {
      components: {
        draggable, BRow, BCol, BSpinner, BButton, VBModal,
      },
  
      props: {
        comData: {
          type: Object,
          required: false,
        },
        dataKey:{
          type: Number,
        },
        dataIndex:{
          type: Number
        },
      },
  
      directives: {
        "b-modal": VBModal,
        Ripple,
      }, 
  
      computed: {
        currentLocale() {
          return  this.$i18n.locale;
        },
      },
  
      setup(props, { emit }) {
        const TablesRepeater = ref([]);
        const Data = ref(props.comData.tables);
        const loadingTable = ref(false);
        console.log('table',Data.value);
        const ChangeTableOrder = async (items) => {
          items.forEach((item, index) => {
            item.ordering_count = index + 1 
          })
  
          loadingTable.value = true;
          emit("ordering-table", items);
        }
        
        const updateTable = async (index) => {
           // alert(index);
          emit('update-table-data', index);
        };
  
        const removeItem = (index)=>{
          if(Data.value[index]){
            Data.value.splice(index,1)
          }
  
          emit('delete-table');
        }
  
        return {
          TablesRepeater,
          Data,
          ChangeTableOrder,
          loadingTable,
          updateTable,
          removeItem,
        };
      },
  
      methods: {
        even: function (arr) {
          // Set slice() to avoid to generate an infinite loop!
          return (Array.from(arr)??[]).slice().sort(function (a, b) {
            return a.ordering_count - b.ordering_count;
          });
        },
      },
    };
  </script>
    